/**
 * Score stars and gifts lying on the road. Shared so the server's score limit knows the biggest boost.
 * A star multiplies the score for a few seconds; the higher the number, the rarer the star.
 * It doesn't stack with Black Star ×2: the bigger of the two counts.
 */
export type StarFactor = 2 | 3 | 4;

export const SCORE_STARS: readonly { factor: StarFactor; weight: number; color: string }[] = [
  { factor: 2, weight: 6, color: '#fcd116' },
  { factor: 3, weight: 3, color: '#f77f00' },
  { factor: 4, weight: 1, color: '#e63946' },
];

/** How long a star's boost lasts, seconds. Picking up another star restarts it (the bigger factor wins). */
export const STAR_SECONDS = 8;

/** The largest score boost from stars or Black Star ×2, for the server's plausibility check. */
export const MAX_SCORE_BOOST = 4;

export type GiftKind = 'cash' | 'fitter';

/** Gifts: a wrapped box of coins (paid by the server like any coin), or a fitter's toolbox that fixes damage. */
export const GIFTS: Record<GiftKind, { name: string; weight: number }> = {
  cash: { name: 'Gift box', weight: 3 },
  fitter: { name: "Fitter's toolbox", weight: 2 },
};

/** Coins inside a gift box (each coin is worth COIN_PESEWAS). */
export const GIFT_COINS = 10;
/** Damage points a fitter's toolbox repairs (the trotro breaks down at 100). */
export const FITTER_REPAIR = 30;
